import { Route, Routes } from "react-router-dom";
import FooterBase from "./FooterBase";

const Footer = () => {

    return (

        <Routes>
            <Route  path='/trans' element={<FooterBase />} />
            <Route  path='/trans/add' element={<FooterBase />} />
            <Route  path='/accumulative' element={<FooterBase />} />
            <Route  path='/settlements' element={<FooterBase />} />
            <Route  path='/installments/factors' element={<FooterBase  />} />
            <Route  path='/authentication' element={<FooterBase  />} />
        </Routes>

    );
}

export default Footer;